import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

// Section for Utilities and Context
import './colleaguelist.css';
import API from "../utils/API";

// Section for Components
import portrait1 from "../assets/portrait-1.png";
import portrait2 from "../assets/portrait-2.png";
import portrait3 from "../assets/portrait-3.png";
import portrait4 from "../assets/portrait-4.png";
import portrait5 from "../assets/portrait-5.png";
import portrait6 from "../assets/portrait-6.png";
import portrait7 from "../assets/portrait-7.png";

// Local Functions
const randomDefaultImage = () => {
    const defaultPicture = [portrait1, portrait2, portrait3, portrait4, portrait5, portrait6, portrait7];
    const randomIndex = Math.floor(Math.random() * defaultPicture.length);
    return defaultPicture[randomIndex];
}

// Main Function
export default function ColleagueList(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [displayedResults] = useState(5);
    const [colleagues, setColleagues] = useState([]);

    useEffect(() => {
        // GET SINGLE PROFILE INFO FROM DATABASE FOR PROFILE PAGE
        const fetchColleagues = async () => {        
            try {

                if (props.division_id != null) {
                    const data = {
                        division_id: props.division_id
                    }
        
                    const response = await API.getDivisionColleagues(data); 
                    // console.log("Fetched Colleague Data:", response.data);
                    setColleagues(response.data);
                } else {

                    const data = {
                        organization_id: props.organization_id
                    }
        
                    const response = await API.getOrganizationColleagues(data); 
                    // console.log("Fetched Colleague Data:", response.data);
                    setColleagues(response.data);
                    // props.reRenderProfile();
                }
                
            } catch (error) {
                console.log("Error fetching single profile:", error);
            }
        };

        fetchColleagues();

    }, [props]);  


    // Convert the `id` from useParams to a number for accurate comparison
    const profileId = parseInt(id, 10);

    // Filter colleagues based on organization and index
    const displayedColleagues = colleagues.filter(colleague =>
        colleague.profile_id !== profileId
    ).slice(0, displayedResults);

    const displayedAllColleagues = colleagues.filter(colleague =>
        colleague.profile_id !== profileId
    );

    const handleNavigate = (colleague_id) => {
        navigate("/profile/" + colleague_id);
    }

    const handleColleagueList = (colleagues, viewAll) => {
        if (colleagues.length === 0) {
            return <div className="py-2 ms-3">No colleagues to show.</div>;
        }
    
        // Filter to ensure unique colleagues by profile_id
        const uniqueColleagues = colleagues
        .filter((colleague, index, self) =>
            index === self.findIndex(c => c.profile_id === colleague.profile_id)
        )
        .filter(colleague => colleague.profile_id !== props.profile_id); // Exclude matching profile_id

    
        const colleagueList = uniqueColleagues.map((colleague) => (
            <div key={colleague.profile_id}
                className="colleague-card"
                onClick={() => handleNavigate(colleague.profile_id)}
                data-bs-dismiss={(!props.viewAll && viewAll) ? "modal" : undefined}
            >
                <img src={colleague.ProfileInfo.profile_picture || randomDefaultImage()}
                    className="colleague-card-picture"
                    alt={`${colleague.ProfileInfo.first_name} ${colleague.ProfileInfo.last_name}`}
                />
                <div className="colleague-card-details">
                    <span className="colleague-card-name">{colleague.ProfileInfo.first_name} {colleague.ProfileInfo.last_name}</span>
                    {colleague.title && (
                        <span className="colleague-card-title">{colleague.title}</span>
                    )}
                    {colleague.Division?.division_name && (
                        <span className="colleague-card-division">{colleague.Division.division_name}</span>
                    )}
                    {colleague.ProfileInfo.work_email && (
                        <a href={"mailto:" + colleague.ProfileInfo.work_email}
                            className="colleague-card-email"
                            onClick={(e) => e.stopPropagation()}
                        >{colleague.ProfileInfo.work_email}</a>
                    )}
                </div>
            </div>
        ));
    
        if (!viewAll) {
            return colleagueList.sort(() => Math.random() - 0.5).slice(0, displayedResults);
        }
    
        return colleagueList;

    }

    return (
        <>
            <div className="colleague-list-subtitle">
                <i className="bi bi-people-fill" />
                Colleagues at {props.colleague_team}
            </div>

            <div className="colleague-card-grid">
                {props.viewAll ? (
                    handleColleagueList(displayedAllColleagues, true)
                ) : (
                    <>
                        {handleColleagueList(displayedColleagues, false)}
                        <div className="colleague-card colleague-view-all-card" data-bs-toggle="modal" data-bs-target="#colleaguesModal">
                            View All Colleagues
                        </div>
                    </>
                )}
            </div>

            {/* Modal to edit the content of the user's bio */}
            {!props.viewAll && (
                <div className="modal fade colleagues-modal" id="colleaguesModal" tabIndex="-1" aria-labelledby="colleaguesModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header colleagues-modal-header">
                                <h5 className="modal-title colleagues-modal-title display-6">Colleagues <i>at</i> {props.colleague_team}</h5>
                            </div>
                            <div className="modal-body colleagues-modal-body">
                                <div className="colleague-card-grid">
                                    {handleColleagueList(displayedAllColleagues, true)}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn modal-close" data-bs-dismiss="modal" alt="Close modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}